import { createIdentifier } from '@wix/thunderbolt-ioc'
import type { IPageWillMountDisposers } from './types'

export const LogicalReflectorSymbol = Symbol('LogicalReflector')
export const LogicalReflectorStateSymbol = Symbol('LogicalReflectorState')
export const FragmentStoresInitializerSymbol = Symbol('FragmentStoresInitializer')

export const name = 'pages' as const
export { VSM_EDITOR_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'

export const PageWillMountDisposersSymbol = createIdentifier<IPageWillMountDisposers>(Symbol('PageWillMountDisposers'))
